import React from 'react';
import { I18n } from '@kineticdata/react';
import moment from 'moment';

export const MaintenanceWrapper = props => {
  // Render form if maintenance attribute is not set
  if (!props.maintenance) {
    return props.children;
  }

  const dates = props.maintenance
    .split(',')
    .filter(Boolean)
    .map(d => d.trim());

  const startDateString = dates.length >= 2 ? dates[0] : null;
  const endDateString = dates.length >= 2 ? dates[1] : dates[0];

  const startDate = startDateString
    ? moment.tz(startDateString, 'America/Chicago')
    : null;
  const endDate = endDateString
    ? moment.tz(endDateString, 'America/Chicago')
    : null;

  if (startDate && !startDate.isValid()) {
    console.error('Invalid start date of Maintenance attribute value.');
  }
  // Render form if endDate for maintenance is invalid
  if (!endDate || !endDate.isValid()) {
    console.error('Invalid end date of Maintenance attribute value.');
    return props.children;
  }
  if (startDate && startDate.isValid() && startDate.isAfter(endDate)) {
    console.error(
      'Invalid Maintenance attribute value. Start date must be before end date.',
    );
    return props.children;
  }

  const now = moment();
  const isInMaintenance =
    endDate.isAfter(now) &&
    (!startDate || !startDate.isValid() || startDate.isBefore(now));

  return isInMaintenance ? (
    <div className="form-maintenance">
      {props.children}
      <div className="form-maintenance--message">
        <div className="form-maintenance--title">
          <I18n>This form is currently undergoing maintenance.</I18n>
        </div>
        <div className="form-maintenance--content">
          <I18n
            render={translate =>
              translate('It is scheduled to be back online by %s.').replace(
                '%s',
                endDate.format('LLLL z'),
              )
            }
          />
        </div>
      </div>
    </div>
  ) : (
    props.children
  );
};
